import { getStoreBuilder } from 'vuex-typex'
import { MainState } from '@/store/main/state'
import { RootState } from '@/store'
import setCurrentPage from '@/store/main/actions/set-current-page';

const initialState: MainState = {
  component: 'feed',
  page: 'statements',
  id: null,
  uid: null,
  forceLogin: false,
  isAuthRequired: false
}

const storeBuilder = getStoreBuilder<RootState>()
const moduleBuilder = storeBuilder.module<MainState>('main', initialState)
const stateReader = moduleBuilder.state()

const mainStore = {
  get state () { return stateReader() },
  get component () { return this.state.component },
  get page () { return this.state.page },
  get id () { return this.state.id },
  get uid () { return this.state.uid },
  get forceLogin () { return this.state.forceLogin },
  get isAuthRequired () { return this.state.isAuthRequired },

  commitSetCurrentPage: moduleBuilder.commit((state: MainState, payload: { component: string, page: string, id?: string|null, uid?: string|null, forceLogin: boolean, isAuthRequired: boolean }) => {
    state.component = payload.component
    state.page = payload.page
    state.id = payload.id ? payload.id : null
    state.uid = payload.uid ? payload.uid : null
    state.forceLogin = payload.forceLogin
    state.isAuthRequired = payload.isAuthRequired
  }, 'setCurrentPage'),

  dispatchSetCurrentPage: moduleBuilder.dispatch(setCurrentPage),
}

export default mainStore
